"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.consoleIntegration = void 0;
var integrations_1 = require("./integrations");
Object.defineProperty(exports, "consoleIntegration", { enumerable: true, get: function () { return integrations_1.consoleIntegration; } });
//# sourceMappingURL=index.js.map